import {getQuestionsFromQuestionaire} from "../../../misc/utils"
import {Grid, Stack} from "@mui/material"
import Typography from "@mui/material/Typography"
import React, {useContext} from "react"
import Widget from "../../../../src/components/Widget"
import {DataContext} from "../../../../src/context/DataContextProvider"
import {getMerkmal} from "../../../misc/widget-functions"

const questionWithAction = (qtc, savePointer, action) => ({...qtc, action, savePointer})

const getAnswerById = (list, qtc) => list?.find(it => it.frageId === qtc.id)?.gewichtung

const PraeferenzfragenGewichtungQuestionaire = ({questionaire, widget}) => {
    const {action} = widget
    const {getDataFromPointer} = useContext(DataContext)
    const questions = getQuestionsFromQuestionaire(questionaire)
    const pointer = getMerkmal(widget)?.pointer
    const praeferenzenList = getDataFromPointer(pointer)
    return (
        <Stack spacing={1}>
            {questions.map(qtc =>
                <Grid
                    padding="2px"
                    backgroundColor="#F1F2FC"
                    container
                    justifyContent="space-between"
                    key={qtc.id}
                    alignItems="center"
                    size={12}
                >
                    <Typography>{qtc?.question}</Typography>
                    <Widget
                        widget={questionWithAction(qtc, pointer, action)}
                        type={qtc?.antworttyp}
                        widgetValue={getAnswerById(praeferenzenList, qtc)}
                    />
                </Grid>
            )}
        </Stack>
    )
}

export default PraeferenzfragenGewichtungQuestionaire